import { Helmet } from "react-helmet-async";
import { abs, DEFAULT_DESCRIPTION, DEFAULT_OG, DEFAULT_TITLE, SITE_NAME } from "./config";

/* Per-page SEO: title, description, canonical, Open Graph, Twitter and JSON-LD schema. */
export function Seo({ title, description, path = "/", image, type = "website", noindex = false, schema = [] }) {
  const t = title || DEFAULT_TITLE;
  const d = description || DEFAULT_DESCRIPTION;
  const canonical = abs(path);
  const og = image || DEFAULT_OG;
  const schemas = Array.isArray(schema) ? schema.filter(Boolean) : [schema].filter(Boolean);
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && <meta name="robots" content="index, follow, max-image-preview:large" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={og} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={t} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={og} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
}
